<template>
    <tr>
        <td>
            <button class="button is-primary" @click="saveItem">
                <i class="fas fa-save"></i>
            </button>
        </td>
        <td>
            <input class="input" v-model="name"/>
        </td>
        <td>
            <input class="input" type="number" v-model="inland_transport"/>
        </td>
        <td>
            <input class="input" type="number" v-model="total"/>
        </td>
        <td></td>
    </tr>
</template>

<script>
    export default {
        computed: {
            name: {
                get() {
                   return this.$store.getters.getCustomInvoiceNewSaleItem.name
                },
                set(value) {
                   this.$store.dispatch('changeCustomInvoiceNewSaleItemFieldValue', { field: 'name', value: value})
                }
            },
            inland_transport: {
                get() {
                    return this.$store.getters.getCustomInvoiceNewSaleItem.inland_transport
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceNewSaleItemFieldValue', { field: 'inland_transport', value: value})
                }
            },
            total: {
                get() {
                    return this.$store.getters.getCustomInvoiceNewSaleItem.total
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceNewSaleItemFieldValue', { field: 'total', value: value})
                }
            }
        },
        methods: {
            saveItem() {
                this.$store.dispatch('saveCustomInvoiceSaleItem')
                this.$store.dispatch('changeCustomInvoiceTotalSaleAmount')
                this.$store.dispatch('calculateCustomInvoice')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceSalesTableCreateRow.vue